export const tr = {
    bannerPrice: 'Reklamdaki fiyat'
};
